module.exports = __webpack_public_path__ + "static/press-dfc749711e289744daa9e1b575bad55a.png";